import { h } from '@/lib/dom';

export interface SkeletonProps {
  variant?: 'text' | 'rect' | 'circle' | 'chart';
  width?: string;
  height?: string;
}

export function Skeleton(props: SkeletonProps = {}): HTMLElement {
  const variant = props.variant ?? 'text';
  let width = props.width ?? '100%';
  let height = props.height ?? '14px';
  let radius = 'var(--radius-sm)';
  if (variant === 'rect') {
    height = props.height ?? '60px';
  } else if (variant === 'circle') {
    width = props.width ?? '32px';
    height = props.height ?? '32px';
    radius = 'var(--radius-full)';
  } else if (variant === 'chart') {
    height = props.height ?? '320px';
    radius = 'var(--radius-md)';
  }
  return h('span', {
    class: 'skeleton',
    aria: { hidden: 'true' },
    style: `width: ${width}; height: ${height}; border-radius: ${radius};`,
  });
}

export function SkeletonList(rows = 3): HTMLElement {
  return h('div', { class: 'skeleton-list', style: 'display: flex; flex-direction: column; gap: 8px;' },
    Array.from({ length: rows }, () => Skeleton({ variant: 'rect', height: '48px' })));
}
